import React, { Fragment, useEffect, useState } from "react";
import { Button, Card, Col, Container, InputGroup, Row, Spinner } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import mastercardLogo from './mastercrd.png';
import { loadFromLocalStorage } from "utils/LocalStorageUtils";
import { apiCall } from "utils/httpClient";
import apiEndPoint from "utils/apiEndPoint";
import { isEmpty } from "utils/utils";
import ResetPassword from "./resetPassword";
import RenewSubscription from "pages/renewsubscription";
import moment from "moment";
import { saveToLocalStorage } from "utils/LocalStorageUtils";
import OrderConfirmation from "pages/orderconfirmation";
import { failedMessage } from "utils/httpClient";

function MyAccount() {
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [showRenewSubscription, setShowRenewSubscription] = useState(false);
  const [showRenewConfirmation, setShowRenewConfirmation] = useState(false);
  const [showDeleteAccount, setShowDeleteAccount] = useState(false);
  const [subscriptionDetail, setSubscriptionDetail] = useState(null);
  const [orderCompleateData, setOrderCompleateData] = useState({});
  const [showSubscription, setShowSubscription] = useState(false);

  const handleCloseReset = () => setShowResetPassword(false);
  const handleShowReset = () => setShowResetPassword(true);

  const handleCloseRenew = () => setShowRenewSubscription(false);
  const handleShowRenew = () => setShowRenewSubscription(true);

  const handleCloseDelete = () => setShowDeleteAccount(false);
  const handleShowDelete = () => setShowDeleteAccount(true);

  const handleShowSubscription = () => setShowSubscription(true);
  const handleCloseSubscription = () => setShowSubscription(false);


  const handleShowConfirmation = () => { setShowRenewSubscription(false); setShowRenewConfirmation(true); getUserDetail(); };
  const handleCloseRenewConfirmation = () => setShowRenewConfirmation(false);

  const [errorMessage, setErrorMessage] = useState({});
  const [userData, setUserData] = useState({});
  const [profileImage, setProfileImage] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [languageData, setLanguageData] = useState(null);
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  useEffect(() => {
    setLanguageData(selectLang?.language)
  }, [selectLang])

  useEffect(() => {
    const authData = loadFromLocalStorage("AUTH_DATA");
    if (authData) {
      setUserData(authData.userDetail)
    }
    getUserDetail()
  }, []);

  async function getUserDetail() {
    const authData = loadFromLocalStorage("AUTH_DATA");
    const { data } = await apiCall("get", apiEndPoint.GETUSERDETAIL);
    if (data.status === 200) {
      setUserData(data.data.userDetail)
      data.data.token = authData?.token
      saveToLocalStorage('AUTH_DATA', data.data)
    }
  }
  async function getSubscriptionDetail() {
    const { data } = await apiCall("get", apiEndPoint.GETSUBSCRIPTIONDETAIL);
    if (data.status === 200) {
      let array = data.data[0]
      array.billing_details = JSON.parse(array?.billing_details)
      setSubscriptionDetail(array)
    }
  }
  async function handleSubscriptionConfirm() {
    const params = { order_id: userData?.subscription?.order_id, subscription_status: 'canceled' }
    const { data } = await apiCall("post", apiEndPoint.SUBSCRIPTIONSTATUSUPDATE, params);
    if (data.status === 200) {
      getUserDetail()
      handleCloseSubscription()
    } else {
      failedMessage(data.message)
      handleCloseSubscription()

    }
  }

  return (
    <Fragment>
      <div className="services-section mt-5">
        <div className="container text-center">
          <h3 className="animate__animated animate__bounce" style={{ fontFamily: 'quicksand', fontWeight: 600, textAlign: 'center', margin: 'auto' }}>
            {languageData?.myAccount}
          </h3>
          <br />
          <p style={{ fontSize: 16, fontWeight: 600, maxWidth: 800, margin: 'auto', color: '#444' }}>
            {languageData?.hereYouCanManageAllYourAccount}
          </p>
        </div>
      </div>
      <Container>
        <div>
          <Card className="mt-5 p-4">
            <div className="mb-4">
              <h5 className="mb-0">{languageData?.accountDetails}</h5>
              <span style={{ display: 'block', borderTop: '2px solid #ff671f', maxWidth: 180 }}></span>
            </div>
            <Row noGutters>
              <Col md={6}>
                <Row>
                  <Form.Label column="sm" lg={3}>
                    {languageData?.fullName} :
                  </Form.Label>
                  <Col>
                    <Form.Control type="text" readOnly placeholder="Enter Name"
                      value={userData?.user_name}
                      onChange={e => {
                        setUserData({
                          ...userData,
                          user_name: e.target.value,
                        });
                      }} />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Form.Label column="sm" lg={3}>
                    {languageData?.email} :
                  </Form.Label>
                  <Col>
                    <Form.Control type="text" placeholder="Enter email"
                      readOnly
                      value={userData?.email}
                      onChange={e => {
                        setUserData({
                          ...userData,
                          email: e.target.value,
                        });
                      }} />
                  </Col>
                </Row>
              </Col>
              <Col md={6}>
                <Row>
                  <Form.Label column="sm" lg={3}>
                    {languageData?.contact} :
                  </Form.Label>
                  <Col>
                    <Form.Control type="text" readOnly placeholder="+91 9994455623"
                      value={`${userData?.mobile}`}
                      onChange={e => {
                        setUserData({
                          ...userData,
                          mobile: e.target.value,
                        });
                      }} />
                  </Col>
                </Row>
              </Col>
            </Row>
            <div className="mt-4">
              <p><strong>{languageData?.haveYouForgetYourPassword}</strong></p>
            </div>
            <Button
              style={{ borderRadius: 15, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
              size='md'
              onClick={handleShowReset}>
              {languageData?.resetPassword}
            </Button>
            <Modal centered show={showResetPassword} onHide={handleCloseReset} style={{ fontFamily: 'quicksand' }}>
              <ResetPassword handleClose={handleCloseReset} />
            </Modal>

            <br /><br />
            <div className="mb-4">
              <h5 className="mb-0">{languageData?.savedPayments}</h5>
              <span style={{ display: 'block', borderTop: '2px solid #ff671f', maxWidth: 180 }}></span>
            </div>
            <Row>
              <Form.Label column="sm" lg={3}>
                {languageData?.debitCardCreditCard}
              </Form.Label>
              <Col lg={6}>
                <InputGroup>
                  <InputGroup.Text>
                    <img
                      src={mastercardLogo}
                      alt="Mastercard Logo"
                      style={{ width: "24px" }}
                    />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="xxxx xxxx xxxx 1234"
                  />
                </InputGroup>
              </Col>
            </Row>
            <br /><br />
            <div className="mb-4">
              <h5 className="mb-0">{languageData?.subscription}</h5>
              <span style={{ display: 'block', borderTop: '2px solid #ff671f', maxWidth: 180 }}></span>
            </div>
            {userData?.subscription != undefined && !isEmpty(userData?.subscription) &&
              <div>
                <p><strong>{languageData?.youHaveBeenSubscribed}</strong></p>
                <p className="mb-0"><strong>{languageData?.startDate} : {userData?.subscription?.start_date != undefined && userData?.subscription?.start_date != '' && moment.unix(userData?.subscription?.start_date).format('Do MMMM, YYYY')}</strong></p>
                <p><strong>{languageData?.endDate} : {userData?.subscription?.end_date != undefined && userData?.subscription?.end_date != '' && moment.unix(userData?.subscription?.end_date).format('Do MMMM, YYYY')}</strong></p>
                {/* {Number(userData?.subscription?.remaining_days) <= 60 && */}
                  <div>
                    <p><strong>{languageData?.yourSubscriptionEndingSoon}</strong></p>
                    <Button
                    disabled={Number(userData?.subscription?.remaining_days) <= 60 ? false : true}
                      style={{ borderRadius: 15, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
                      size='md'
                      onClick={() => { handleShowRenew(); getSubscriptionDetail() }}>
                      {languageData?.renewNow}
                    </Button> <br />
                    <span style={{ fontSize: 12, color: '#f00'}}>{languageData?.WhenYourRemainingDaysLessThan}</span>
                  </div>
                {/* } */}
                <br />

                {userData?.subscription?.subscription_status === "canceled" ?
                  <div>
                    <p><strong> {languageData?.yourSubscriptionHasBeenCanceled}</strong></p>
                  </div>
                  :
                  <div>
                    <p><strong>{languageData?.doYouWishToCancelYourSubscription}</strong></p>
                    <Button style={{ borderRadius: 15, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
                      size='md' onClick={handleShowSubscription}>
                      {languageData?.cancelSubscription}
                    </Button>
                  </div>
                }
              </div>
            }
            <Modal centered show={showRenewSubscription} onHide={handleCloseRenew} style={{ fontFamily: 'quicksand' }} size="xl">
              <RenewSubscription handleCloseRenew={handleCloseRenew} subscriptionDetail={subscriptionDetail} setSubscriptionDetail={setSubscriptionDetail} handleShowConfirmation={handleShowConfirmation} setOrderCompleateData={setOrderCompleateData} />
            </Modal>
            <Modal centered show={showRenewConfirmation} onHide={handleCloseRenewConfirmation} style={{ fontFamily: 'quicksand' }} size="xl">
              <OrderConfirmation handleBack={handleCloseRenewConfirmation} orderCompleateData={orderCompleateData} />
            </Modal>

            <Modal centered show={showDeleteAccount} onHide={handleCloseDelete} style={{ fontFamily: 'quicksand' }}>
              <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: 18, fontWeight: 600 }}>{languageData?.deleteAccount}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>{languageData?.areYouSureYouWantToDelete}</p>
              </Modal.Body>
              <Modal.Footer>
                <Button style={{ margin: '5px', borderRadius: 15, width: 'inherit', fontSize: 12, fontWeight: 500 }} size='md' variant="secondary" onClick={handleCloseDelete}>
                  {languageData?.cancel}
                </Button>
                <Button style={{ margin: '5px', borderRadius: 15, width: 'inherit', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }} size='md' onClick={handleCloseDelete}>
                  {languageData?.confirm}
                </Button>
              </Modal.Footer>
            </Modal>

            {/* Cancel Subscription */}
            <Modal centered show={showSubscription} onHide={handleCloseSubscription} style={{ fontFamily: 'quicksand' }}>
              <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: 18, fontWeight: 600 }}>{languageData?.cancelSubscription}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>{languageData?.areYouSureYouWantToCancelYourSubscription}</p>
              </Modal.Body>
              <Modal.Footer>
                <Button style={{ margin: '5px', borderRadius: 15, width: 'inherit', fontSize: 12, fontWeight: 500 }} size='md' variant="secondary" onClick={handleCloseSubscription}>
                  {languageData?.cancel}
                </Button>
                <Button style={{ margin: '5px', borderRadius: 15, width: 'inherit', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }} size='md' onClick={handleSubscriptionConfirm}>
                  {languageData?.confirm}
                </Button>
              </Modal.Footer>
            </Modal>
            <br />
            <div className="mb-4">
              <h5 className="mb-0">{languageData?.otherSettings}</h5>
              <span style={{ display: 'block', borderTop: '2px solid #ff671f', maxWidth: 180 }}></span>
            </div>
            <p><strong>{languageData?.doYouWishToDeleteYourAccount}</strong></p>
            <Button
              style={{ borderRadius: 15, width: 'fit-content', fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
              size='md'
              onClick={handleShowDelete}>
              {languageData?.deleteAccount}
            </Button>
          </Card>
        </div>
      </Container>
    </Fragment>
  );
}

export default MyAccount;
